import React, { Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter, Redirect } from 'react-router-dom';

// Global Components
import LoadingSpinner from '~/common/components/LoadingSpinner';
// View Components
import Customize from '~/views/Billing/Customize';
import Checkout from '~/views/Billing/Checkout';
import OrderSummary from '~/views/Billing/OrderSummary';

import Icon from '~/common/images/img-icon-arrow-right-small.svg';

// Consts
import { PATH_ERROR } from '~/common/utils/consts.js';


import Tracking from '~/common/utils/gaTracking';
import { mapEcommerceItems } from '~/common/utils/trackingHelpers';

// Import Stylesheet
import styles from './billing.css';

@withRouter
@inject(
    'fatalErrorStore',
    'checkoutStore',
    'formsStore',
    'locationStore',
    'contentStore',
    'flexFrameStore')
@observer
export default class Billing extends React.Component {
    constructor(props) {
        super(props);
        this.onBeforeUnload = this.onBeforeUnload.bind(this);
        this.tracking = new Tracking();
        this.tracking.form = 'buy-form';
    }

    onBeforeUnload() {
        const { dirty, submitted } = this.props.formsStore;
        if (dirty && !submitted) {
            this.tracking.trackAbandonment();
        }
    }

    componentDidMount() {
        const { contentStore, checkoutStore, upgrade } = this.props;
        // tracking
        const wrapper = document.querySelector('#buyFormWrapper');
        const { brand: trackingProduct } = checkoutStore;
        let trackingData = {
            trackingProduct
        };
        if (wrapper && wrapper.dataset.tealiumTags) {
            trackingData = Object.assign({}, trackingData, JSON.parse(wrapper.dataset.tealiumTags));
        }
        this.tracking.data = trackingData;
        // pull the content from the api, if its an upgrade flow grab upgrade content
        if (!contentStore.contentLoaded) {
            contentStore.loadLabelContent(upgrade);
        }

        this.tracking.trackLoadForm();
        window.addEventListener('beforeunload', this.onBeforeUnload);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.onBeforeUnload);
    }

    nextSteps(location, forward = false) {
        if (forward) {
            this.tracking.trackCartUpdateIfNeeded({
                ecommerce: mapEcommerceItems({
                    selectedPlan: this.props.checkoutStore.selectedPlan,
                    billingPeriod: this.props.formsStore.BillingPeriod,
                    currencyCode: this.props.contentStore.contentData.CurrencyCode,
                    licenseSelector: this.props.formsStore.LicenseSelector,
                    selectedAddons: this.props.checkoutStore.selectedAddons
                })
            });
        }
        this.props.history.push(location);
    }

    render() {
        // if a store has returned a fatal error redirect to the error page
        const { fatalErrorStore, checkoutStore, contentStore, flexFrameStore, locationStore, upgrade } = this.props;
        if (fatalErrorStore.fatalError) return <Redirect push={true} to={PATH_ERROR} />;
        const { isLoading, brand } = checkoutStore;
        const { keyId } = flexFrameStore;
        const { labelContent } = contentStore;
        const location = this.props.history.location.pathname;
        const prevStep = upgrade ? '/user1' : '/';
        const nextStep = upgrade ? '/user1-checkout' : '/checkout';
        const isCheckout = location === '/checkout' || location === '/user1-checkout';
        // fire tracking that the form has loaded
        if (!isLoading) {
            if (window.fireTealiumLinkEvent) window.fireTealiumLinkEvent('form display', 'G2M Purchase Form');
        }

        if (isCheckout && !keyId) {
            if (locationStore.fetchedCountries) {
                checkoutStore.setupFlex();
            }
        }

        return (
            isLoading || (isCheckout && !keyId) ?
                <LoadingSpinner />
                :
                <Fragment>
                    <section className={styles.wrapper}>
                        <div className={styles.heading}>
                            <h1>{!isCheckout ? labelContent.CustomizePlan : labelContent.Checkout}</h1>
                            <div className={styles.subnav}>
                                <a
                                    className={`${!isCheckout ? styles.disabled : ''} ${brand ? styles[`disabled--${brand}`] : ''}`}
                                    onClick={() => this.nextSteps(prevStep)}
                                >{labelContent.CustomizePlan}</a>
                                <img className={styles.arrow} src={Icon} />
                                <a
                                    className={`${isCheckout ? styles.disabled : ''} ${brand ? styles[`disabled--${brand}`] : ''}`}
                                    onClick={() => this.nextSteps(nextStep, true)}
                                >{labelContent.Checkout}</a>
                            </div>
                        </div>
                        <form className={styles.form}>
                            <div className={styles.column}>
                                {isCheckout ?
                                    <Checkout />
                                    :
                                    <Customize nextSteps={() => this.nextSteps(nextStep, true)} />
                                }
                            </div>
                            <div className={`${styles.column} ${styles['order-summary']}`}>
                                <OrderSummary />
                            </div>
                        </form>
                    </section>
                </Fragment>
        );
    }
}
